module.exports = __webpack_public_path__ + "img/time.787bf450.svg";